<template>
  <div
    class="counselor-grid__section-header"
    ref="root"
    :class="{ 'is-stuck': isStuck }"
  >
    <button
      class="counselor-grid__filter-toggle"
      type="button"
      v-if="isMobile || isTablet"
      @click.prevent="toggleFiltersVisibility"
    >
      <svg aria-hidden="true" class="icon">
        <use xlink:href="#filter" />
      </svg>
      <span v-text="texts.refineSearch" />
    </button>
    <p v-if="isMobile || isTablet" v-text="numberOfFiltersText" />

    <div
      class="counselor-grid__sort-by"
      v-if="!(isMobile || isTablet) && showSortBy"
    >
      <div class="counselor-grid__sort-by-label">
        <svg aria-hidden="true" class="icon"><use xlink:href="#sort" /></svg>
        <span aria-hidden="true" v-text="texts.sortBy" />
        <span aria-hidden="true" v-text="sortByLabel" />
      </div>
      <select v-model="sortByModel">
        <option
          v-for="option in sortByOptions"
          :key="option.value"
          :value="option.value"
          v-text="option.label"
        />
      </select>
    </div>

    <div class="view-switcher" v-if="!isMobile">
      <div
        class="view-switcher__button"
        v-for="option in viewOptions"
        :key="option"
        :class="{ active: view === option }"
      >
        <label>
          <svg aria-hidden="true" class="icon">
            <use :xlink:href="`#${option}`" />
          </svg>
          <span class="screen-reader-text">{{ viewLabels[option] }}</span>
          <input
            class="btn"
            type="radio"
            v-model="viewModel"
            :class="{
              'grid-btn': option === 'grid',
              'list-btn': option === 'list',
              selected: view === option,
            }"
            :value="option"
          >
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import { useStuck } from "Composables/useStuck";
  import { useIsMobile } from "Main/composables/useIsMobile";
  import { getCounselorGridSortByOptions } from "Services/types/counselor-grid-service-sort-option-types";
  import { sprintf } from "sprintf-js";
  import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

  export default {
    computed: {
      ...mapState("counselorGrid", ["view", "viewOptions", "sortBy"]),
      ...mapGetters("counselorGrid", ["numOfSetFilters"]),

      numberOfFiltersText() {
        if (this.numOfSetFilters === 1) {
          return this.texts.oneFilterApplied;
        }

        return sprintf(this.texts.numberOfFiltersApplied, this.numOfSetFilters);
      },

      sortByLabel() {
        const sortByOption = this.sortByOptions.find(
          (option) => option.value === this.sortBy
        );

        return sortByOption ? sortByOption.label : this.sortByOptions[0].label;
      },

      sortByModel: {
        get() {
          return this.$store.state.counselorGrid.sortBy;
        },
        set(value) {
          this.setSortBy(value);
        },
      },

      viewLabels() {
        return { grid: this.texts.gridView, list: this.texts.listView };
      },

      viewModel: {
        get() {
          return this.$store.state.counselorGrid.view;
        },
        set(value) {
          this.setView(value);
        },
      },
    },

    created() {
      if (this.isMobile) {
        this.initialMobileView();
      }

      if (this.isTablet) {
        this.initialTabletView();
      }
    },

    data() {
      return {
        sortByOptions: getCounselorGridSortByOptions(this.role),
        texts: window.theme_vars.counselorGridTexts,
      };
    },

    methods: {
      ...mapMutations("counselorGrid", [
        "setView",
        "setFiltersAreVisible",
        "setSortBy",
      ]),
      ...mapActions("counselorGrid", ["toggleFiltersVisibility"]),

      initialMobileView() {
        this.setView("grid");
        this.setFiltersAreVisible(false);
      },

      initialTabletView() {
        this.setFiltersAreVisible(false);
      },
    },

    mounted() {
      this.watchStuck(this.$refs.root);
    },
    name: "CounselorGridHeader",

    props: {
      role: {
        default: null,
        type: String,
      },
      showSortBy: {
        default: false,
        type: Boolean,
      },
    },

    setup() {
      const { isMobile, isTablet } = useIsMobile();
      const { isStuck, watchStuck } = useStuck();
      return { isMobile, isStuck, isTablet, watchStuck };
    },

    watch: {
      isMobile() {
        this.initialMobileView();
        this.watchStuck(this.$refs.root);
      },

      isTablet() {
        this.initialTabletView();
        this.watchStuck(this.$refs.root);
      },
    },
  };
</script>
